 <script>
     export let corLetraRodape;
     export let corAreaRodape;
     export let textoRodape="";
 </script>

    <footer class="text-center" style="background-color:{corAreaRodape} ; color:{corLetraRodape}">
	   {#if textoRodape!=""}
     <div class="row text-center">
     <div class="col">
     <p>{textoRodape}
     </p>
     </div>
     </div>
     {:else}
		<p>&nbsp;</p><p>&nbsp;</p>
		<p> Quer ter seu próprio microsite (o novo conceito de cartão de visita)? <a href="http://www.linkagenda.com.br/cartoesvisita/index.php?tipo=microsite&escola=andlline">clique aqui</a></p>
	  <img src="http://www.linkagenda.com.br/criativo/img/AndllineSoftware.png" width="50" height="50" alt=""/>
		
<div class="container">
    <div class="row">
      <div class="col-12">
		  <p> www.linkangenda.com.br
			  <br> www.andlline.com.br
        <br> © ANDLLINE SOFTWARE. Todos os direitos reservados.</p>
		   
		  
      </div>
    </div>
    </div>

    {/if}
    </footer>